import { updateLicenseType } from "../../../../../actions/Utilities/LicenseType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { LicenseTypeInfo } from "../types";

const useEditLicenseType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (newData: LicenseTypeInfo) =>
      updateLicenseType(newData),
    {
      onSuccess: (res: any) => {
        if (res.data === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetLicenseType"]);
          toast.fire("Success", "License Type Updated Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Saving Failed", "Failed to Update License Type!", "error");
      },
    }
  );
  return mutate;
};
export default useEditLicenseType;

